import styled from 'styled-components'
import { Link } from "react-router-dom";

export const Wrapper = styled.div`
   
    
    border-radius: 5px;
    min-height: 60px;
    max-width:100%;
    display: grid;
    grid-auto-flow:column;
    grid-template-columns: 8fr 1fr;
    box-shadow: 0 5px 9px white inset, 0 5px 9px grey;
    background-color: var(--secondaryColor);

    @media screen and (max-width: 490px) {
       
        }

`

export const Image = styled.img`

    width: 100%;
    max-width: 50px;
    max-height:50px;
    transition: all 2s;
    object-fit: cover;
    margin:auto;
    border-radius: 50%;
    box-shadow: 0 5px 9px white inset, 0 5px 9px grey;
    

    :hover {
        transform: rotateY(360deg);
        opacity: 80%;
    }

`;

export const Content = styled.div`
display: grid;
grid-auto-flow: column;
grid-template-columns: 1fr;
align-items:center;
margin:10px;
    text-align: center;
    position: relative;
    padding: 5px;
    font-size: large;
    font-family: 'Times New Roman', Times, serif;

    @media screen and (max-width: 550px) {
    display: flex; /* Flexbox for better control */
    flex-direction: row; /* Stack items vertically */
    align-items: center; /* Center text and image */
    font-size: small;
    text-align: center;
    padding: 10px;

}

`;

export const Data = styled.div`

    display:grid;
    padding:5px;
    font-size: large;
    
    @media screen and (max-width: 550px) {
        font-size: small;

    }

`
export const StyledLink = styled(Link)`
display: grid;

grid-template-columns: 1fr 1fr 1fr;
align-items:center;
margin:10px;
max-width:100%;
text-align: center;
text-decoration: none;
color: black;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        cursor: pointer;
    }

@media screen and (max-width: 550px) {
    display: flex; /* Flexbox for better control */
    flex-direction: row; /* Stack items vertically */
    align-items: center; /* Center text and image */
    text-align: center;
  
    padding: 10px;

}


`;